
import type { PropType } from 'vue'
import type { IndexMessages } from '../../models'
import { computed, defineComponent, ref } from 'vue'
import { UiModal } from '../keen-ui'
import { EpbButton, EpbKeywords, EpbTextbox } from '../shared'

export default defineComponent({
  name: 'IndexJobNewInstanceModal',
  components: {
    EpbButton,
    EpbKeywords,
    EpbTextbox,
    UiModal,
  },
  props: {
    messages: {
      type: Object as PropType<IndexMessages['newInstanceModal']>,
      required: true,
    },
  },
  emits: {
    save: (pluginId: string, feeds: string[]) => {},
  },
  setup(_, { emit }) {
    const baseClass = 'epb-index-job-new-instance-modal'

    const pluginId = ref('')
    const feeds = ref([])
    const modal = ref()

    const valid = computed(() => {
      return pluginId.value && feeds.value.length > 0
    })

    const open = (): void => {
      pluginId.value = ''
      feeds.value = []
      modal.value.open()
    }

    const close = (): void => {
      modal.value.close()
    }

    const save = (): void => {
      emit('save', pluginId.value, feeds.value)
    }

    return {
      baseClass,
      modal,
      pluginId,
      feeds,
      valid,
      open,
      close,
      save,
    }
  },
})
